import React, { useEffect, useMemo, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Container,
  FormHelperText,
  InputAdornment,
} from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import LoadingButton from "../../../LoadingButton"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import useStyles from "./styles"
import { toggleAddDiscountDialog } from "../../../../actions/billingDialogs"

const AddDiscountDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [localDiscount, setLocalDiscount] = useState(0)
  const [working, toggleWorking] = useState(false)
  const open = useSelector(state => state.billingDialogs.addDiscountDialogOpen)

  const data = useSelector(state => state.billingDialogs.data)
  const discount = (data && data.discount) || 0
  const addDiscountFunc = (data && data.addDiscountFunc) || null
  const funcArgs = (data && data.funcArgs) || []

  const handleClose = () => {
    dispatch(toggleAddDiscountDialog(false))
    setTimeout(() => {
      setLocalDiscount(0)
      toggleWorking(false)
    }, 300)
  }

  //when the component mounts or opens, set the local discount to the discount in the general data
  useEffect(
    () => {
      setLocalDiscount(discount)
    },
    [discount, open]
  )

  let error = useMemo(
    () => {
      if (data && data.total && localDiscount) {
        return Number(data.total) < Number(localDiscount)
      } else {
        return false
      }
    },
    [data, localDiscount]
  )

  const handleSubmit = () => {
    toggleWorking(true)
    if (addDiscountFunc) {
      addDiscountFunc(...funcArgs, {
        discount: localDiscount,
      })
    }
    handleClose()
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <Box textAlign="center">
        <DialogTitle disableTypography>
          <Typography variant="h3">Discount this shoot?</Typography>
        </DialogTitle>
        <DialogContent>
          <Container>
            <FormControl>
              <InputLabel htmlFor="standard-adornment-amount">
                Discount
              </InputLabel>
              <Input
                type="number"
                autoFocus
                style={
                  error
                    ? { border: "1px solid red", fontSize: "1.5rem" }
                    : { fontSize: "1.5rem" }
                }
                id="standard-adornment-amount"
                value={localDiscount}
                onChange={e => {
                  setLocalDiscount(e.target.value)
                }}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
              />
              <FormHelperText error={error}>
                {error ? "Discount is too high" : ""}
              </FormHelperText>
            </FormControl>
          </Container>
        </DialogContent>
        <DialogActions className={classes.buttons}>
          <LoadingButton
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={handleClose}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            variant="contained"
            color="primary"
            working={working}
            className={classes.button}
            onClick={handleSubmit}
            disabled={error}
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default AddDiscountDialog
